// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1vkRe","label":"CategoryService_label__3OU_R","location":"CategoryService_location__1RDn9"};